import OSS from 'ali-oss';
import { getServiceOssUploadUrl, postUploadToken, getImgUploadUrl } from "@/api/index";
import { put } from "@/utils/axios";
import axios from "axios";
import { convertBase64UrlToBlob } from "@/utils/common";

let cancelTokenSource = axios.CancelToken.source();

export const newOss = async (file, options = { reName: "rewriteCanvas.png" }) => {
    return new Promise((resolve) => {
        let timestamp = (new Date()).valueOf();
        let userInfo = JSON.parse(localStorage.getItem("userInfo"));
        //获取当前年月
        let nowDate = new Date();
        let nowMonth = nowDate.getMonth() + 1;
        if (nowMonth < 10) {
            nowMonth = '0' + nowMonth;
            nowMonth = nowMonth.toString();
        }
        const fileName = file.name ? `${encodeURIComponent(file.name)}` : `${timestamp}_${options.reName}`

        getServiceOssUploadUrl({
            path: `ai/train/${userInfo.user_id}_${timestamp}_${fileName}`,
            "headers-content-type": file.type,
        }).then(res => {
            put(res.data, file, {
                headers: {
                    "Content-Type": file.type, // 设置请求头的 Content-Type，
                },
                cancelToken: cancelTokenSource.token
            }).then(_ => {
                let fileUrl = res.data.split('?')[0];
                resolve(fileUrl);
            }).catch(error => {
                if (axios.isCancel(error)) {
                    console.log('Upload canceled', error.message);
                }
            });
        })
    })
}

export const newOssV2 = async (file) => {
    const timestamp = (new Date()).valueOf();
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    // 获取当前年月
    const nowDate = new Date();
    const nowYear = nowDate.getFullYear().toString();
    let nowMonth = nowDate.getMonth() + 1;
    if (nowMonth < 10) {
        nowMonth = '0' + nowMonth;
        nowMonth = nowMonth.toString();
    }
    const uploadPath = process.env.REACT_APP_ENV === 'pro' ? ('ai/reference_image/' + nowYear + nowMonth) : 'aiim/test';
    const fileName = file.name;
    const fileExtension = fileName?.slice((fileName?.lastIndexOf(".") - 1 >>> 0) + 2);
    // console.log('newOssV2...', fileName, fileExtension);
    const fileReName = `${uploadPath}/${userInfo.user_id}_${timestamp}.${fileExtension}`;
    const { url, link } = await ossUpload(fileReName, file);
    return link;
}

// 图片扩展名 -> Content-Type 映射，需与后端签名时使用的 Content-Type 保持一致
const IMG_CONTENT_TYPE_MAP = {
    png: 'image/png',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    webp: 'image/webp',
    gif: 'image/gif',
    bmp: 'image/bmp',
};

// 基于签名URL直传：调用 /api/v1/upload/getImgUploadUrl 获取带签名的临时上传链接后直传OSS
export const newOssV3 = async (file) => {
    const timestamp = (new Date()).valueOf();
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    // 获取当前年月
    const nowDate = new Date();
    const nowYear = nowDate.getFullYear().toString();
    let nowMonth = nowDate.getMonth() + 1;
    if (nowMonth < 10) {
        nowMonth = '0' + nowMonth;
        nowMonth = nowMonth.toString();
    }
    const uploadPath = process.env.REACT_APP_ENV === 'pro' ? 'ai/reference_image' : 'ai/test';
    const fileName = file.name;
    // Blob对象无name属性（如URL转存场景），扩展名兜底为png
    const fileExtension = (fileName?.slice((fileName?.lastIndexOf(".") - 1 >>> 0) + 2) || 'png').toLowerCase();
    const fileReName = `${uploadPath}/${userInfo.user_id}_${timestamp}.${fileExtension}`;
    // 获取带签名的临时上传链接
    const res = await getImgUploadUrl({ upload_url: fileReName });
    if (res?.status !== 200 || !res?.data?.url) {
        throw new Error(res?.msg || '获取上传链接失败');
    }
    const { url, img_domain, uri } = res.data;
    // 后端返回的直传链接可能固定为 http，在 https 页面下会被浏览器按 Mixed Content 拦截。
    // OSS 签名串只包含 method/headers/Expires/资源路径，不包含协议，因此 https 页面下降级替换协议即可。
    const uploadUrl = window.location.protocol === 'https:' ? url.replace(/^http:/, 'https:') : url;
    // 后端签名时已将 Content-Type 纳入签名串（PUT + Content-Type + Expires + 资源路径），
    // 直传时必须携带与扩展名一致的 Content-Type，否则 OSS 返回 SignatureDoesNotMatch。
    // 不使用业务axios实例（拦截器会附加imToken/Authorization，可能引发CORS问题）。
    const body = await file.arrayBuffer();
    const contentType = IMG_CONTENT_TYPE_MAP[fileExtension] || 'image/png';
    const doPut = (type) => fetch(uploadUrl, {
        method: 'PUT',
        headers: { 'Content-Type': type },
        body,
    });
    let putRes = await doPut(contentType);
    // 后端若固定以 image/png 参与签名（与路径扩展名无关），则回退重试一次
    if (putRes.status === 403 && contentType !== 'image/png') {
        putRes = await doPut('image/png');
    }
    if (!putRes.ok) {
        throw new Error('图片上传失败');
    }
    return img_domain + uri;
};



export const ossUpload = async (fileName, file) => {
    const ossRes = await postUploadToken({});
    const client = new OSS({
        region: ossRes.Endpoint.split('.')[0],
        accessKeyId: ossRes.AccessKeyId,
        accessKeySecret: ossRes.AccessKeySecret,
        stsToken: ossRes.SecurityToken,
        refreshSTSToken: async () => {
            // 向您搭建的STS服务获取临时访问凭证。
            return {
                accessKeyId: ossRes.AccessKeyId,
                accessKeySecret: ossRes.AccessKeySecret,
                stsToken: ossRes.SecurityToken,
            };
        },
        expiration: ossRes.Expiration,
        // 刷新临时访问凭证的时间间隔，单位为毫秒。
        refreshSTSTokenInterval: 300000,
        // 填写Bucket名称。
        bucket: ossRes.Bucket,
    });
    const { name, res, url } = await client.put(fileName, file);
    const link = `${ossRes.img_domain}/${fileName}`; // 图片链接
    return { name, res, url, link };
};

export const uploadBase64ImageToOSS = async (base64Image, imgExt = 'png') => {
    const ossRes = await postUploadToken({});
    const client = new OSS({
        region: ossRes.Endpoint.split('.')[0],
        accessKeyId: ossRes.AccessKeyId,
        accessKeySecret: ossRes.AccessKeySecret,
        stsToken: ossRes.SecurityToken,
        refreshSTSToken: async () => {
            // 向您搭建的STS服务获取临时访问凭证。
            return {
                accessKeyId: ossRes.AccessKeyId,
                accessKeySecret: ossRes.AccessKeySecret,
                stsToken: ossRes.SecurityToken,
            };
        },
        expiration: ossRes.Expiration,
        // 刷新临时访问凭证的时间间隔，单位为毫秒。
        refreshSTSTokenInterval: 300000,
        // 填写Bucket名称。
        bucket: ossRes.Bucket,
    });
    const file = convertBase64UrlToBlob(base64Image);
    // console.log('file...', file)
    // 获取当前年月
    const nowDate = new Date();
    const nowYear = nowDate.getFullYear().toString();
    let nowMonth = nowDate.getMonth() + 1;
    if (nowMonth < 10) {
        nowMonth = '0' + nowMonth;
        nowMonth = nowMonth.toString();
    }
    const timestamp = (new Date()).valueOf();
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    const uploadPathUrl = `ai/redraw/output/${process.env.REACT_APP_ENV === 'pro' ? 'pro/' : 'test/'}${nowYear}${nowMonth}` 
    const fileName = `${uploadPathUrl}/${userInfo.user_id}_${timestamp}.${imgExt}`;
    const { res } = await client.put(fileName, file);
    if (res.status === 200) {
        return `${ossRes.img_domain}/${fileName}`;
    } else {
        return ''
    }
};